import { ApiModel } from "../models/models"
import { DaoBase } from "./dao-base"

export class ArrayDao<T> extends DaoBase<T> {
  constructor() {
    super()
    this.options = {
      sortDirection: "asc",
      sortField: null,
    }
    this.allDataRetrieved = true
  }

  public async setData(data: T[]): Promise<void> {
    this.totalData.next(data)
    this.refreshData()
  }

  public async deleteItem(id: string, deleteItemOnServer?: () => Promise<void>): Promise<void> {
    const updatedData = this.totalData.value.filter((item: ApiModel) => item._id !== id)
    this.totalData.next(updatedData)
    if (deleteItemOnServer) {
      await deleteItemOnServer()
    }
    await this.refreshData()
  }

  /**
   * Takes the current totalData and then filters, searches, and sorts that data
   */
  public async refreshData(): Promise<void> {
    this.updateCachedData(this.totalData.value)
  }

  public async initialize(): Promise<void> {
    this.loading.next(true)
    const values = await this.getDataItems()
    this.totalData.next(values)
    await this.refreshData()
    this.loading.next(false)
  }
}

export class StaticArrayDao<T> extends ArrayDao<T> {
  constructor(
    public staticData: T[],
  ) {
    super()
  }

  public async getDataItems(): Promise<T[]> {
    return this.staticData
  }
}
